// extracted by mini-css-extract-plugin
export default {"container":"nZ0XY7sMS9IbyjD9ggJ2","lineItem":"ZO0Y7XkVEvNaiczyy4Hd","label":"CrLHp5JNnPyxKeKverXG","value":"k99Biorgs_pxsKjPGtdA","subtext":"fTL3XAYiGQE5HbYTInBy"};